import { useEffect, useState } from "react";

const MWEB_MQ = "(max-width: 1024px)";

export function useIsMweb(): boolean {
  const [isMweb, setIsMweb] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(MWEB_MQ).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(MWEB_MQ);
    const onChange = () => setIsMweb(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isMweb;
}
